var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.panelOptionsDefinition)?_c('DetailView',{attrs:{"schema":_vm.panelOptionsDefinition.schema,"item":_vm.panelOptionsDefinition.item,"hide-edit-btn":true,"display-in":"info"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }